import { useQuery } from '@sequencehq/api'
import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { MINUTES } from '@sequencehq/utils/dates'

import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { usePublishedQuote } from 'Cube/view/layouts/quote/hooks'
import { useQuoteRecipientRows } from 'Cube/view/layouts/quote/components/QuoteRecipientsNotifyList'

/**
 * Who is left to write to about this quote.
 *
 * The published variant is what recipients were sent, so it is the only thing
 * that knows who has signed and who was last emailed. It isn't fetched for an
 * expired quote though, so we fall back to the quote in front of us - that
 * still lists everybody, and nobody can have signed an expired quote anyway.
 */
export const useNotifiableRecipients = () => {
  const ctx = useCubeContext()
  const publishedQuote = usePublishedQuote().data

  const quoteSettingsRes = useQuery(
    dashboardv20240509Client.getQuoteSettings,
    undefined,
    { staleTime: 5 * MINUTES }
  )

  const recipients = useQuoteRecipientRows(
    publishedQuote ?? ctx.queries.rawData.data.quote,
    {
      // Countersigners stay hidden until the setting has answered, so we never
      // offer a row and then take it away underneath someone.
      notifyCounterSignerLast:
        quoteSettingsRes.data?.notifyCounterSignerLast ??
        quoteSettingsRes.isLoading,
      excludeSigned: true
    }
  )

  return recipients
}
